import './App.css';
import Navbar from './Components/Navbar'
import FirstCard from './Components/FirstCard'
import SecondCard from './Components/SecondCard'
import Contact from './Components/Contact'
import Privacy from './Components/Privacy'
import Login from './Components/Login'
import ThirdCard from './Components/ThirdCard'

import Footer from './Components/Footer'

import { BrowserRouter, Route } from "react-router-dom";


function App() {
  return (
    <>
      <BrowserRouter>
        <div className="App">
          <Navbar />
          <Route exact path='/'>
            <FirstCard />
            <SecondCard />
            <ThirdCard />
          </Route>
          <Route path='/start'>
            <Contact />
          </Route>
          <Route path='/privacy'>
            <Privacy />
          </Route>
          <Route path='/login'>
            <Login />
          </Route>
          <Footer />
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
